import Icon from "ds/components/Icon";
import { ManagedUserGroup } from "types/generated";
import { getProviderLogo } from "views/Account/Settings/Users/helpers";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

const IdpGroupMappingTableLoginMethodCell = ({
  item: group,
  ...cellProps
}: TableSimpleCellProps<ManagedUserGroup>) => {
  const ProviderIcon = getProviderLogo(group.identityProvider);

  return (
    <TableSimpleCell {...cellProps}>
      {!ProviderIcon && <TableCellEmpty />}
      {ProviderIcon && (
        <TableCellText>
          {typeof ProviderIcon === "string" ? (
            ProviderIcon
          ) : (
            <Icon size="large" src={ProviderIcon} />
          )}
        </TableCellText>
      )}
    </TableSimpleCell>
  );
};

export default IdpGroupMappingTableLoginMethodCell;
